import {createAction, props} from '@ngrx/store';
import {Strategy} from '@app/shared/models/portfolio/strategy.model';

export const fetchStrategies = createAction('[Strategy] Fetch Strategies');

export const fetchStrategiesSuccess = createAction('[Strategy] Fetch Strategies Success', props<{response: Strategy[]}>());
